import { callApiToServer } from "../callApi";

export async function deleteCharity(authtoken, charityId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      charityId: charityId,
    });

    let endUrl = "v1/auth/charity";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
